// Arabic translations for RewardsManagement component
const arRewardsManagement = {
    rewards: {
      title: 'إدارة المكافآت',
      subtitle: 'تكوين وإدارة مكافآت العملاء',
  
      tabs: {
        tiers: 'مستويات المكافآت',
        promotions: 'العروض الترويجية',
        redemptions: 'سجل الاسترداد',
        settings: 'الإعدادات'
      },
  
      tiers: {
        current: 'مستويات المكافآت الحالية',
        create: 'إنشاء مستوى مكافآت جديد',
        empty: 'لم يتم إنشاء مستويات مكافآت بعد. قم بإنشاء أول مستوى مكافآت للبدء.',
        points: 'نقطة',
  
        form: {
          name: 'اسم المستوى',
          pointsRequired: 'النقاط المطلوبة',
          description: 'الوصف',
          emoji: 'الرمز التعبيري',
          active: 'نشط',
          noDescription: 'لا يوجد وصف متاح',
          image: 'صورة',
          addImage: 'اضافة صورة',
          changeImage: 'تغيير الصورة',
  
          placeholder: {
            name: 'مثل: برونزي، فضي، ذهبي',
            points: 'الحد الأدنى من النقاط المطلوبة',
            description: 'وصف المكافآت المتاحة في هذا المستوى'
          },
  
          buttons: {
            create: 'إنشاء مستوى مكافآت',
            update: 'حفظ التغييرات',
            cancel: 'إلغاء',
            edit: 'تعديل',
            delete: 'حذف'
          }
        }
      },
  
      promotions: {
        current: 'العروض الترويجية الحالية',
        create: 'إنشاء عرض ترويجي جديد',
        empty: 'لم يتم إنشاء عروض ترويجية بعد. قم بإنشاء أول عرض ترويجي لتقديم فرص نقاط خاصة.',
        multiplier: '',
  
        dates: {
          from: 'من',
          to: 'إلى'
        },
  
        form: {
          name: 'اسم العرض الترويجي',
          multiplier: 'مضاعف النقاط',
          startDate: 'تاريخ البدء',
          endDate: 'تاريخ الانتهاء',
          description: 'الوصف',
          active: 'نشط',
          noDescription: 'لا يوجد وصف متاح',
          expiredNote: ' يجب ان يكون التاريخ فعّال',
  
          placeholder: {
            name: 'مثل: عطلة نهاية الأسبوع بنقاط مضاعفة',
            multiplier: 'مثل: 2 لنقاط مضاعفة',
            description: 'وصف العرض الترويجي وأي شروط خاصة'
          },
  
          buttons: {
            create: 'إنشاء عرض ترويجي',
            update: 'حفظ التغييرات',
            cancel: 'إلغاء',
            edit: 'تعديل',
            delete: 'حذف'
          }
        }
      },
  
      redemptions: {
        history: 'سجل الاسترداد',
        empty: 'لا يوجد سجل استرداد متاح. سيتم تعبئة هذا القسم عندما يقوم العملاء باسترداد نقاطهم.',
        
        stats: {
          total: 'إجمالي عمليات الاسترداد',
          points: 'النقاط المستردة',
          average: 'متوسط الاسترداد'
        },
        
        table: {
          date: 'التاريخ',
          customer: 'العميل',
          points: 'النقاط المستردة',
          reward: 'المكافأة',
          status: 'الحالة'
        },
  
        status: {
          completed: 'مكتمل',
          pending: 'قيد الانتظار',
          cancelled: 'ملغي',
          processing: 'قيد المعالجة'
        }
      },
  
      settings: {
        title: 'إعدادات المكافآت العامة',
        success: 'تم تحديث الاعدادات بنجاح',
        birthdayDiscount:{
          label: "نسبة عيد الميلاد",
          hint: "نسبة الخصم المطبّقة على عروض اعياد الميلاد"
        },
        
        pointsPerDollar: {
          label: 'النقاط لكل شيكل منفق',
          hint: 'هذا هو المعدل الأساسي لحساب النقاط. يمكن للعروض الترويجية تعديل هذا المعدل مؤقتًا.'
        },
        
        expiration: {
          label: 'انتهاء صلاحية النقاط (بالأشهر)',
          hint: 'اضبطه على 0 لعدم انتهاء الصلاحية. وإلا، ستنتهي صلاحية النقاط بعد هذا العدد من الأشهر.'
        },
        
        minRedemption: {
          label: 'الحد الأدنى من النقاط للاسترداد',
          hint: 'يجب أن يكون لدى العملاء على الأقل هذا العدد من النقاط لاسترداد المكافآت.'
        },
        
        save: 'حفظ الإعدادات'
      },
  
      confirm: {
        deleteTier: 'هل أنت متأكد أنك تريد حذف مستوى المكافأة هذا؟',
        deletePromo: 'هل أنت متأكد أنك تريد حذف العرض الترويجي هذا؟'
      },
  
      success: {
        tierUpdated: 'تم تحديث مستوى المكافأة بنجاح',
        tierCreated: 'تم إنشاء مستوى مكافأة جديد بنجاح',
        tierDeleted: 'تم حذف مستوى المكافأة بنجاح',
        promoUpdated: 'تم تحديث العرض الترويجي بنجاح',
        promoCreated: 'تم إنشاء عرض ترويجي جديد بنجاح',
        promoDeleted: 'تم حذف العرض الترويجي بنجاح',
        settingsUpdated: 'تم تحديث الإعدادات بنجاح'
      },
  
      errors: {
        fetchFailed: 'فشل في تحميل بيانات المكافآت. يرجى المحاولة مرة أخرى.',
        requiredFields: 'اسم المستوى والنقاط المطلوبة حقول إلزامية',
        promoRequiredFields: 'اسم العرض الترويجي وتاريخ البدء وتاريخ الانتهاء حقول إلزامية',
        updateTierFailed: 'فشل في تحديث مستوى المكافأة. يرجى المحاولة مرة أخرى.',
        createTierFailed: 'فشل في إنشاء مستوى المكافأة. يرجى المحاولة مرة أخرى.',
        deleteTierFailed: 'فشل في حذف مستوى المكافأة. يرجى المحاولة مرة أخرى.',
        updatePromoFailed: 'فشل في تحديث العرض الترويجي. يرجى المحاولة مرة أخرى.',
        createPromoFailed: 'فشل في إنشاء العرض الترويجي. يرجى المحاولة مرة أخرى.',
        deletePromoFailed: 'فشل في حذف العرض الترويجي. يرجى المحاولة مرة أخرى.',
        updateSettingsFailed: 'فشل في تحديث الإعدادات. يرجى المحاولة مرة أخرى.'
      }
    },
  
    common: {
      loading: 'جاري التحميل...',
      saving: 'جاري الحفظ...',
      creating: 'جاري الإنشاء...',
      updating: 'جاري التحديث...',
      
      status: {
        active: 'نشط',
        inactive: 'غير نشط'
      }
    }
  };
  
  export default arRewardsManagement;